import {
    verifyCodeLogin,
    passwordLogin,
    personalInfo,
    getPreviewUrl,
    openGetUser
} from '@/api/index.js'
import { getToken, setToken, removeToken } from "@/helper/auth";

const user = {
    state: {
        token: getToken(),
        isLogin: JSON.parse(localStorage.getItem('isLogin')) || false,
        announcementId: "1",
        phoneNumber: JSON.parse(localStorage.getItem('phoneNumber')) || "",
        userName: JSON.parse(localStorage.getItem('userName')) || "",
        miniProgramPersonId: JSON.parse(localStorage.getItem('miniProgramPersonId')) || "",
        profilePhoto: JSON.parse(localStorage.getItem('profilePhoto')) || "",
        auditStatus: JSON.parse(localStorage.getItem('auditStatus')) || '',
        functionalStatus: JSON.parse(localStorage.getItem('functionalStatus')) || '',
        aboutUsId: "1",
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_PHONENUMBER: (state, phoneNumber) => {
            state.phoneNumber = phoneNumber;
            localStorage.setItem('phoneNumber', JSON.stringify(phoneNumber))
        },
        SET_USERNAME: (state, userName) => {
            state.userName = userName;
            localStorage.setItem('userName', JSON.stringify(userName))
        },
        SET_STATUS: (state, isLogin) => {
            state.isLogin = isLogin;
            localStorage.setItem('isLogin', JSON.stringify(isLogin))
        },
        SET_MiniProgramPersonId: (state, miniProgramPersonId) => {
            state.miniProgramPersonId = miniProgramPersonId;
            localStorage.setItem('miniProgramPersonId', JSON.stringify(miniProgramPersonId))
        },
        SET_PHOTO: (state, profilePhoto) => {
            state.profilePhoto = profilePhoto;
            localStorage.setItem('profilePhoto', JSON.stringify(profilePhoto))
        },
        SET_AnnouncementId: (state, announcementId) => {
            state.announcementId = announcementId;
        },
        SET_AUDIT: (state, auditStatus) => {
            state.auditStatus = auditStatus;
            localStorage.setItem('auditStatus', JSON.stringify(auditStatus))
        },
        SET_FUNCTIONAL: (state, functionalStatus) => {
            state.functionalStatus = functionalStatus;
            localStorage.setItem('functionalStatus', JSON.stringify(functionalStatus))
        },
        SET_AboutUsId(state, aboutUsId) {
            state.aboutUsId = aboutUsId;
        },
    },

    actions: {
        // 验证码登录
        verifyCodeLogin({ commit }, userForm) {
            const phoneNumber = userForm.phoneNumber;
            const verifyCode = userForm.verifyCode
            return new Promise((resolve, reject) => {
                verifyCodeLogin(phoneNumber, verifyCode).then(res => {
                    if (res.code == 200) {
                        setToken(res.data.token);
                        commit('SET_TOKEN', res.data.token)
                        commit('SET_STATUS', 'true')
                        commit('SET_PHONENUMBER', res.data.phoneNumber);
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },


        // 企业登录
        Login({ commit }, userForm) {
            const username = userForm.phoneNumber;
            const password = userForm.userPassword
            return new Promise((resolve, reject) => {
                passwordLogin(username, password).then(res => {
                    if (res.code == 200) {
                        setToken(res.data.token);
                        commit('SET_TOKEN', res.data.token)
                        commit('SET_STATUS', 'true')
                        commit('SET_PHONENUMBER', res.data.phoneNumber);
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                personalInfo().then(res => {
                    if (res.code == 200) {
                        if (res.data.reMiniProgramPerson) {
                            commit('SET_MiniProgramPersonId', res.data.reMiniProgramPerson.miniProgramPersonId)
                            commit('SET_USERNAME', res.data.reMiniProgramPerson.realName);
                        }
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },


        // 获取头像
        PreviewUrlPhoto({ commit }, profilePhoto) {
            return new Promise((resolve, reject) => {
                getPreviewUrl(profilePhoto).then(res => {
                    if (res.code == 200) {
                        commit('SET_PHOTO', res.msg)
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },


        // 获取审核状态
        GetUserOpen({ commit, state }) {
            return new Promise((resolve, reject) => {
                openGetUser().then((res) => {
                    commit('SET_AUDIT', res.auditStatus)
                    commit('SET_FUNCTIONAL', res.functionalStatus)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                localStorage.clear();
                resolve()
            })
        }
    }
}

export default user
